import { StatesCalculateService } from '@festina/collcalc-general-types/collcalc/services/StatesCalculateService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method = StatesCalculateService.collCalcCalculateServicePostCalculate
type MethodParam = Parameters<typeof method>[0]

export const useSubmitCollCalcCalculation = ({
  tenantId,
}: {
  tenantId: string
}) =>
  useFestinaMutation({
    component: 'collCalc',
    roles: StatesCalculateService.collCalcCalculateServicePostCalculate_roles,
    isScenario: false,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ xTenantId: tenantId, ...arg }),
  })
